module.exports = "https://cdn.realtymogul.com/static/media/social_ig_gray.f0a2db19.svg";